export default __webpack_public_path__ + "static/media/error.c15ebdb6.mp3";